import { finish } from '../../../modules/user/actions/logout';

import api from '../../../api';

export function request(dispatch, action) {
    api.request('DELETE', '/session', {
        email: action.email,
        password: action.password
    }).then(
        ({ data }) => dispatch(finish()),
        ({ errors }) => dispatch(finish())
    );
}
